import React, { useState, useEffect, useCallback } from 'react'
import { Right } from '../components/List'
import Icon from '../components/Icon'
import Potency from '../components/ThreePhase/Potency'
import MetricGroup from '../components/ThreePhase/MetricGroup'
import { useAppDispatch, useAppSelector } from '../hooks'
import {
  View,
  TouchableOpacity,
  Text,
  StyleSheet, Platform, SafeAreaView
} from 'react-native'
import WsActions from '../redux/ws'
import moment from 'moment'
import TitleLoading from '../components/TitleLoading'
import { ECharts } from '../components/ECharts'
import { HeaderButton, HeaderButtons, Item } from 'react-navigation-header-buttons'
import { get } from 'lodash'
import Utils from '../redux/utils'
import { parseMultipliers } from '../util'
import BlurView from '../components/BlurView'
import { t, gettext } from 'ttag'
import MyioDatePicker from '../components/MyioDatePicker'
import { useAppTheme } from '#app/theme'
import { useNavigation } from '@react-navigation/native'
import SegmentedControl from '@react-native-segmented-control/segmented-control'

const IoniconsHeaderButton = (props: any) => {
  return (
    <HeaderButton
      {...props}
      IconComponent={Icon}
      iconSize={23}
      color={props.color}
    />
  )
}

export default function EnergyThreePhase () {
  const dispatch = useAppDispatch()
  const [selectedTab, setSelectedTab] = useState(0)

  const [period] = useState([{ label: gettext('Day'), value: 'hour' }, { label: gettext('Month'), value: 'day' }, { label: gettext('Year'), value: 'month' }])
  const [selectedPeriod, setSelectedPeriod] = useState({ label: gettext('Day'), value: 'hour' })

  const navigation = useNavigation()
  const theme = useAppTheme()

  const { consumptionThreePhase } = useAppSelector(state => state.consumption)

  const years = Utils.getYearList()

  const months = [
    { label: gettext('JANUARY'), value: '01' },
    { label: gettext('FEBRUARY'), value: '02' },
    { label: gettext('MARCH'), value: '03' },
    { label: gettext('APRIL'), value: '04' },
    { label: gettext('MAY'), value: '05' },
    { label: gettext('JUNE'), value: '06' },
    { label: gettext('JULY'), value: '07' },
    { label: gettext('AUGUST'), value: '08' },
    { label: gettext('SEPTEMBER'), value: '09' },
    { label: gettext('OCTOBER'), value: '10' },
    { label: gettext('NOVEMBER'), value: '11' },
    { label: gettext('DECEMBER'), value: '12' }
  ]

  const [showPickerDate, setShowPickerDate] = useState(false)
  const [date, setDate] = useState(moment().set({ hour: 0, minutes: 0, seconds: 0 }).toDate())
  const [month, setMonth] = useState(months.find(m => m.value === moment().format('MM')))
  const [year, setYear] = useState(years.find(m => m.value === moment().format('YYYY')))

  useEffect(() => {
    dispatch({ type: 'RESET_CONSUMPTION_THREE_PHASE' })
    updateWs()
    return () => {
      dispatch({ type: 'CLEAR_CONSUMPTION_THREE_PHASE' })
    }
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [])

  useEffect(() => {
    if (selectedTab === 1) updateData()
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [date, month, year, selectedPeriod, selectedTab, dispatch])

  const updateWs = useCallback(() => {
    if (get(consumptionThreePhase, 'selectedThreePhase.type') !== 'three_phase_sensor') return
    subscribe()
    checkSelectedType('check_potency')
    checkSelectedType('check_current')
    checkSelectedType('check_voltage')
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dispatch])

  const updateData = useCallback(() => {
    let payload = {}

    if (selectedPeriod.value === 'hour') {
      payload = { period: 'hour', date: moment(date, 'DD/MM/YYYY').toDate() }
    } else if (selectedPeriod.value === 'day') {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload = { period: 'day', month: month.value, year: year.value }
    } else if (selectedPeriod.value === 'month') {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload = { period: 'month', year: year.value }
    }

    if (moment(date, 'DD/MM/YYYY', true).isValid()) {
      dispatch({ type: 'GET_THREE_PHASE_CONSUMPTION_REQUEST', payload })
    }
  }, [date, month, year, selectedPeriod, dispatch])

  useEffect(() => {
    navigation.setOptions({
      title: get(consumptionThreePhase, 'selectedThreePhase.name'),
      headerRight: () => {
        return (
          <HeaderButtons HeaderButtonComponent={IoniconsHeaderButton}>
            <Item
              title={t`Refresh`}
              iconName="refresh"
              onPress={() => {
                dispatch({ type: 'RESET_CONSUMPTION_THREE_PHASE' })
                updateWs()
                if (selectedTab === 1) updateData()
              }}
            />
          </HeaderButtons>
        )
      }
    })
  },
  [navigation, dispatch, updateWs, updateData, consumptionThreePhase, selectedTab])

  const subscribe = useCallback(() => {
    dispatch(WsActions.wsConnectionSendMessage({
      command: 'subscribe',
      id: get(consumptionThreePhase, 'selectedThreePhase.slave_id'),
      scope: 'slave',
      type: 'consumption'
    }))
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dispatch])

  const checkSelectedType = useCallback((command) => {
    dispatch(WsActions.wsConnectionSendMessage({
      type: 'slave',
      id: get(consumptionThreePhase, 'selectedThreePhase.slave_id'),
      command
    }))
  }, // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [dispatch])

  const getDate = () => {
    return moment(date).startOf('day').tz('America/Sao_Paulo').format('DD/MM/YYYY').toString()
  }

  const getChartDf = () => {
    const deviceName = get(consumptionThreePhase, 'selectedThreePhase.name', '')
    const { powerMultiplier } = parseMultipliers(deviceName)

    let df = consumptionThreePhase.consumptionData.values.map((c: any) => {
      return {
        value: [c.label, parseFloat(c.value) * powerMultiplier]
      }
    })

    if (selectedPeriod.value !== 'hour') {
      df = consumptionThreePhase.consumptionData.values.map((c: any) => {
        return {
          value: [moment.utc(c.label).format('YYYY-MM-DD'), parseFloat(c.value) * powerMultiplier]
        }
      })
    }

    return df
  }

  const getChartTooltipFormatter = () => {
    let formatter = (params: any) => {
      const date = new Date(params[0].value[0])
      const value = parseFloat(params[0].value[1]).toFixed(2)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      const dt = ('0' + date.getHours()).substr(-2) + ':' + ('0' + date.getMinutes()).substr(-2)
      return `${dt}</br>${value}kWh`
    }

    if (selectedPeriod.value === 'day') {
      formatter = (params) => {
        const date = new Date(params[0].value[0])
        const value = parseFloat(params[0].value[1]).toFixed(2)
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const dt = ('0' + date.getUTCDate()).substr(-2) + '/' + ('0' + (date.getUTCMonth() + 1)).substr(-2) + '/' + ('0' + date.getUTCFullYear()).substr(-2)
        return `${dt}</br>${value}kWh`
      }
    } if (selectedPeriod.value === 'month') {
      formatter = (params) => {
        const date = new Date(params[0].value[0])
        const value = parseFloat(params[0].value[1]).toFixed(2)
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        const dt = ('0' + (date.getUTCMonth() + 1)).substr(-2) + '/' + ('0' + date.getUTCFullYear()).substr(-2)
        return `${dt}</br>${value}kWh`
      }
    }

    return formatter
  }

  const getChartAxisLabelFormatter = () => {
    let formatter = (value: any, index: any) => {
      const dt = new Date(value)
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
      return ('0' + dt.getHours()).substr(-2) + 'H'
    }

    if (selectedPeriod.value === 'day') {
      // @ts-expect-error ts-migrate(2322) FIXME: Type '(value: any, index: any) => number' is not a... Remove this comment to see the full error message
      formatter = (value, index) => {
        const dt = new Date(value)
        return dt.getUTCDate()
      }
    } else if (selectedPeriod.value === 'month') {
      formatter = (value, index) => {
        const dt = new Date(value)
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
        return ('0' + dt.getUTCMonth()).substr(-2)
      }
    }

    return formatter
  }

  const getChartOptions = () => {
    return {
      xAxis: {
        show: true,
        type: 'category',
        maxInterval: 3600 * 1000 * 24,
        axisLine: {
          lineStyle: { color: theme.textColor }
        },
        axisLabel: {
          formatter: getChartAxisLabelFormatter()
        }
      },
      yAxis: {
        show: true,
        type: 'value',
        axisLine: {
          lineStyle: { color: theme.textColor }
        },
        splitLine: { show: false }
      },
      series: [{
        data: getChartDf(),
        type: 'bar',
        itemStyle: { normal: { color: theme.colors.default } }
      }],
      grid: { left: 25, top: 15, right: 25, bottom: 25 },
      tooltip: {
        show: true,
        trigger: 'axis',
        formatter: getChartTooltipFormatter(),
        axisPointer: { type: 'none' }
      }
    }
  }

  const formatConsumption = (consumption: any, hour: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (consumptionThreePhase.timeoutWsRequest) { return '-' }

    const deviceName = get(consumptionThreePhase, 'selectedThreePhase.name', '')
    const { powerMultiplier } = parseMultipliers(deviceName)
    const adjustedConsumption = consumption * powerMultiplier

    if (adjustedConsumption < 1000) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/strict-boolean-expressions
      return Math.ceil(adjustedConsumption) + ' W' + (hour ? 'h' : '')
    } else {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      return (adjustedConsumption / 1000).toFixed(2) + ' kW' + (hour ? 'h' : '')
    }
  }

  const formatAmperage = (amperage: any, hour: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (consumptionThreePhase.timeoutWsRequest) { return '-' }

    const deviceName = get(consumptionThreePhase, 'selectedThreePhase.name', '')
    const { currentMultiplier } = parseMultipliers(deviceName)
    const adjustedAmperage = amperage * currentMultiplier

    if (adjustedAmperage < 1000) {
      // eslint-disable-next-line @typescript-eslint/restrict-plus-operands, @typescript-eslint/strict-boolean-expressions
      return Math.ceil(adjustedAmperage) + ' mA' + (hour ? 'h' : '')
    } else {
      // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
      return (adjustedAmperage / 1000).toFixed(2) + ' A' + (hour ? 'h' : '')
    }
  }

  const formatPowerFactor = (value: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (consumptionThreePhase.timeoutWsRequest) { return '-' }
    return value
  }

  const formatVoltage = (voltage: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (consumptionThreePhase.timeoutWsRequest) { return '-' }

    const deviceName = get(consumptionThreePhase, 'selectedThreePhase.name', '')
    const { voltageMultiplier } = parseMultipliers(deviceName)
    const adjustedVoltage = voltage * voltageMultiplier

    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return parseFloat(adjustedVoltage.toFixed(2)) + ' V'
  }

  const verifyLoading = (loading: any) => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (consumptionThreePhase.timeoutWsRequest) { return false }
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if (loading) { return true }
  }

  const renderDatePicker = () => {
    if (selectedPeriod.value === 'hour') {
      if (Platform.OS !== 'web') {
        return (
          <View style={styles.flexPicker}>
            <TouchableOpacity
              onPress={() => { setShowPickerDate(!showPickerDate) }}
              style={[theme.form.inputTouchable, theme.border]}
            >
              <Text style={{ fontSize: 15, color: theme.textColor }}>{getDate()}</Text>
              <Right>
                <Icon name="chevron-down-circle-outline" size={20} color={theme.colors.grey} />
              </Right>
            </TouchableOpacity>

            {showPickerDate && (
              <MyioDatePicker date={date} theme={theme} onDateChange={setDate} />
            )}
          </View>
        )
      } else {
        return (
          <View style={styles.flexPicker}>
            <MyioDatePicker date={date} theme={theme} onDateChange={setDate} />
          </View>
        )
      }
    }
  }

  const renderLiveTab = () => {
    if (get(consumptionThreePhase, 'selectedThreePhase.type') === 'three_phase_sensor') {
      return (
        <View style={{ paddingHorizontal: 5, paddingTop: 4 }}>
          <Text style={[styles.sectionLabel, { color: theme.colors.grey }]}>{t`Power`}</Text>
          <MetricGroup
            total={{
              label: gettext('Current Power'),
              // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
              loading: verifyLoading(isNaN(consumptionThreePhase.potency.phases.a)),
              value: formatConsumption(parseFloat(consumptionThreePhase.potency.phases.a) + parseFloat(consumptionThreePhase.potency.phases.b) + parseFloat(consumptionThreePhase.potency.phases.c), false)
            }}
            phases={[
              {
                label: gettext('Phase A'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.potency.phases.a)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatConsumption(consumptionThreePhase.potency.phases.a)
              },
              {
                label: gettext('Phase B'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.potency.phases.b)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatConsumption(consumptionThreePhase.potency.phases.b)
              },
              {
                label: gettext('Phase C'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.potency.phases.c)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatConsumption(consumptionThreePhase.potency.phases.c)
              }
            ]}
          />

          <Text style={[styles.sectionLabel, { color: theme.colors.grey }]}>{t`Current`}</Text>
          <MetricGroup
            phases={[
              {
                label: gettext('Phase A'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.current.phases.a)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatAmperage(consumptionThreePhase.current.phases.a)
              },
              {
                label: gettext('Phase B'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.current.phases.b)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatAmperage(consumptionThreePhase.current.phases.b)
              },
              {
                label: gettext('Phase C'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.current.phases.c)),
                // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
                value: formatAmperage(consumptionThreePhase.current.phases.c)
              }
            ]}
          />

          <Text style={[styles.sectionLabel, { color: theme.colors.grey }]}>{t`Power Factor`}</Text>
          <MetricGroup
            phases={[
              {
                label: gettext('Phase A'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.fp.a)),
                value: formatPowerFactor(consumptionThreePhase.voltage.fp.a)
              },
              {
                label: gettext('Phase B'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.fp.b)),
                value: formatPowerFactor(consumptionThreePhase.voltage.fp.b)
              },
              {
                label: gettext('Phase C'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.fp.c)),
                value: formatPowerFactor(consumptionThreePhase.voltage.fp.c)
              }
            ]}
          />

          <Text style={[styles.sectionLabel, { color: theme.colors.grey }]}>{t`Voltage`}</Text>
          <MetricGroup
            phases={[
              {
                label: gettext('Phase A'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.phases.a)),
                value: formatVoltage(consumptionThreePhase.voltage.phases.a)
              },
              {
                label: gettext('Phase B'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.phases.b)),
                value: formatVoltage(consumptionThreePhase.voltage.phases.b)
              },
              {
                label: gettext('Phase C'),
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'boolean | undefined' is not assignable to type 'boolean | undefined'.
                loading: verifyLoading(isNaN(consumptionThreePhase.voltage.phases.c)),
                value: formatVoltage(consumptionThreePhase.voltage.phases.c)
              }
            ]}
          />
        </View>
      )
    }

    return (
      <View style={{ paddingHorizontal: 5, paddingTop: 4, flexDirection: 'row' }}>
        <Potency
          label={t`Current consumption`}
          // @ts-expect-error ts-migrate(2322) FIXME: Type '{ label: string; loading: boolean; value: st... Remove this comment to see the full error message
          loading={isNaN(get(consumptionThreePhase, 'selectedThreePhase.lastConsumption'))}
          // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
          value={`${get(consumptionThreePhase, 'selectedThreePhase.lastConsumption')} W`}
        />
      </View>
    )
  }

  const renderConsumptionTab = () => {
    return (
      <View style={{ flex: 1 }}>
        <View style={[theme.form.formGroup, theme.pb0, { marginBottom: 0, flexDirection: 'row' }]}>
          <TouchableOpacity
            onPress={() => {
              navigation.navigate('ModalPicker', {
                name: gettext('Period'),
                data: period,
                value: selectedPeriod,
                search: true,
                multiple: false,
                required: true,
                onPressOk: (data: any) => {
                  setSelectedPeriod(data.selectedItem)
                }
              })
            }}
            style={[theme.form.inputTouchable, styles.flexPicker, theme.border]}
          >
            <Text style={{ fontSize: 15, color: theme.textColor }}>{selectedPeriod.label}</Text>
            <Right>
              <Icon name="chevron-down-circle-outline" size={20} color={theme.colors.grey} />
            </Right>
          </TouchableOpacity>
        </View>

        <View style={[theme.form.formGroup, theme.pb0, { marginBottom: 0, flexDirection: 'row' }]}>
          {renderDatePicker()}

          {selectedPeriod.value === 'day' &&
            <View style={[styles.flexPicker, {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center'
            }]}
            >
              <TouchableOpacity
                onPress={() => {
                  navigation.navigate('ModalPicker', {
                    name: gettext('Select an month...'),
                    data: months,
                    value: month,
                    search: true,
                    multiple: false,
                    required: true,
                    onPressOk: (data: any) => {
                      setMonth(data.selectedItem)
                    }
                  })
                }}
                style={[theme.form.inputTouchable, theme.border, {
                  justifyContent: 'center',
                  width: '50%',
                  borderTopEndRadius: 0,
                  borderBottomEndRadius: 0,
                  borderRightWidth: 0
                }]}
              >
                {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
                <Text style={{ fontSize: 15, color: theme.textColor }}>{month.label}</Text>
                <Right>
                  <Icon name="chevron-down-circle-outline" size={20} color={theme.colors.grey} />
                </Right>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => {
                  navigation.navigate('ModalPicker', {
                    name: gettext('Select a year...'),
                    data: years,
                    value: year,
                    search: true,
                    multiple: false,
                    required: true,
                    onPressOk: (data: any) => {
                      setYear(data.selectedItem)
                    }
                  })
                }}
                style={[theme.form.inputTouchable, theme.border, {
                  justifyContent: 'center',
                  width: '50%',
                  borderTopStartRadius: 0,
                  borderBottomStartRadius: 0,
                  borderLeftWidth: 0
                }]}
              >
                {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
                <Text style={{ fontSize: 15, color: theme.textColor }}>{year.label}</Text>
                <Right>
                  <Icon name="chevron-down-circle-outline" size={20} color={theme.colors.grey} />
                </Right>
              </TouchableOpacity>
            </View>}

          {selectedPeriod.value === 'month' &&
            <TouchableOpacity
              onPress={() => {
                navigation.navigate('ModalPicker', {
                  name: gettext('Select a year...'),
                  data: years,
                  value: year,
                  search: true,
                  multiple: false,
                  required: true,
                  onPressOk: (data: any) => {
                    setYear(data.selectedItem)
                  }
                })
              }}
              style={[theme.form.inputTouchable, styles.flexPicker, theme.border]}
            >
              {/* @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'. */}
              <Text style={{ fontSize: 15, color: theme.textColor }}>{year.label}</Text>
              <Right>
                <Icon name="chevron-down-circle-outline" size={20} color={theme.colors.grey} />
              </Right>
            </TouchableOpacity>}
        </View>

        <View style={{ paddingHorizontal: 5, paddingTop: 4, flexDirection: 'row' }}>
          <Potency
            label={`${gettext('Consumption of')} ${selectedPeriod.label}`}
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ label: string; loading: boolean; value: st... Remove this comment to see the full error message
            loading={isNaN(consumptionThreePhase.consumptionData.totalValue)}
            value={formatConsumption(consumptionThreePhase.consumptionData.totalValue, true)}
          />
        </View>

        <View style={[theme.mb3, {
          flex: 1,
          flexDirection: 'column',
          alignItems: 'stretch',
          display: 'flex',
          padding: 5
        }]}
        >
          <BlurView
            tint={theme.blurView.tint} intensity={theme.blurView.intensity}
            style={[theme.border, theme.p3, { height: '100%' }]}
          >
            {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '(string &... Remove this comment to see the full error message */}
            <TitleLoading loading={consumptionThreePhase.loading} text={t`Consumption until now`} style={{ flex: 1 }} />
            {consumptionThreePhase?.consumptionData?.values != null && (
              <View style={{ flex: 2 }}>
                <ECharts
                  // @ts-expect-error ts-migrate(2322) FIXME: Type '{ option: { xAxis: { show: boolean; type: st... Remove this comment to see the full error message
                  option={getChartOptions()}
                  backgroundColor="transparent"
                />
              </View>
            )}
          </BlurView>
        </View>
      </View>
    )
  }

  return (
    <SafeAreaView style={{ flex: 1 }}>
      <View style={{ paddingHorizontal: 12, paddingVertical: 10 }}>
        <SegmentedControl
          values={[t`Live`, t`Consumption`]}
          selectedIndex={selectedTab}
          onChange={(event) => setSelectedTab(event.nativeEvent.selectedSegmentIndex)}
        />
      </View>

      {selectedTab === 0 ? renderLiveTab() : renderConsumptionTab()}
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  flexPicker: {
    flexGrow: 1,
    flexShrink: 1,
    flexBasis: 0,
    margin: 5
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 1.2,
    textTransform: 'uppercase',
    marginTop: 12,
    marginBottom: 2,
    marginLeft: 6
  }
})
